import { BaseNode } from "./baseNode";

export const LLMNode = ({ id }) => {
  return (
    <BaseNode
      id={id}
      title="LLM"
      leftHandles={[
        { id: `${id}-system`, top: '33%', label: 'System' },
        { id: `${id}-prompt`, top: '66%', label: 'Prompt' }
      ]}
      rightHandles={[
        { id: `${id}-response`, top: '50%', label: 'Response' }
      ]}
    >
      <div>
        This is a LLM.
      </div>
    </BaseNode>
  );
};
